import { computed } from 'vue'
import { currentTimestamp } from '@/helpers/date'
import { DateTime } from 'luxon'

export const useCardChallenge = () => {

  const endDate = DateTime.fromISO('2025-04-07', { zone: 'utc' }).set({
    hour: 10,
    minute: 0,
    second: 0,
    millisecond: 0,
  }).toSeconds()

  const hasChallengeEnded = computed(() => {
    return endDate - currentTimestamp() <= 0
  })

  return {
    hasChallengeEnded,
  }
}